"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentVersionLogsByIds = void 0;
const tslib_1 = require("tslib");
const uniq_1 = tslib_1.__importDefault(require("lodash/uniq"));
const cache_1 = require("../__common/cache");
const contentVersionLogQueryHelper_1 = require("./common/contentVersionLogQueryHelper");
function getCachedDataFromIds(rp, contentVersionLogIds) {
    const cachedData = [];
    const uncachedIds = [];
    contentVersionLogIds.forEach(contentVersionLogId => {
        const contentVersionLog = cache_1.getFromCache(rp, contentVersionLogId);
        if (contentVersionLog) {
            cachedData.push(contentVersionLog);
        }
        else {
            uncachedIds.push(contentVersionLogId);
        }
    });
    return { cachedData, uncachedIds };
}
function getContentVersionLogsByIds(rp, filters) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        let contentVersionLogIds = filters[0].values;
        contentVersionLogIds = uniq_1.default(contentVersionLogIds);
        const { cachedData: cachedContentVersionLogs, uncachedIds: uncachedContentVersionLogIds } = getCachedDataFromIds(rp, contentVersionLogIds);
        let contentVersionLogs = cachedContentVersionLogs;
        if (uncachedContentVersionLogIds.length > 0) {
            filters[0].values = uncachedContentVersionLogIds;
            const size = 100;
            const remainingContentVersionLogs = yield contentVersionLogQueryHelper_1.loadContentVersionLogsFromVersionLogIds([filters[0]], size);
            remainingContentVersionLogs.map((contentVersionLog) => cache_1.putIntoCache(rp, contentVersionLog._id, contentVersionLog));
            contentVersionLogs = contentVersionLogs.concat(remainingContentVersionLogs);
        }
        return { contentVersionLogs, total: contentVersionLogs.length };
    });
}
exports.getContentVersionLogsByIds = getContentVersionLogsByIds;
//# sourceMappingURL=getContentVersionLogsByIds.js.map